import {
  AfterViewInit,
  Component,
  inject,
  OnDestroy,
  OnInit,
  TemplateRef,
} from '@angular/core';

import { Breadcrumb, BreadcrumbsService, PageTitleBarService } from '@iss/core/portal';

@Component({
  standalone: true,
  template: '',
})
export abstract class PageComponent implements OnInit, OnDestroy, AfterViewInit {
  protected readonly bread = inject(BreadcrumbsService);
  private readonly titleBar = inject(PageTitleBarService);

  protected abstract readonly breadcrumbs: Breadcrumb[];

  public title?: TemplateRef<unknown>;

  public ngOnInit(): void {
    this.bread.update(this.breadcrumbs);
  }

  public ngAfterViewInit(): void {
    if (this.title) {
      this.titleBar.show(this.title);
    }
  }

  public ngOnDestroy(): void {
    this.bread.clear();
    this.titleBar.destroy();
  }
}
